"use strict";import{Tooltip as o}from"./src/Tooltip.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-tooltip",o);
//# sourceMappingURL=sp-tooltip.js.map
